function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* eslint react/prop-types: 0 */
import React from 'react';
import CBrand from '../utils/CBrand'; //component - CoreUI / CHeaderBrand

var CHeaderBrand = function CHeaderBrand(props) {
  return /*#__PURE__*/React.createElement(CBrand, _extends({}, props, {
    className: ['c-header-brand', props.className]
  }));
};

export default CHeaderBrand;